import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../../environments/environment';
import { Auth0SessionService } from './auth0-session.service';

/** One identity boundary for permission caches, client selection and shell controls. */
@Injectable({ providedIn: 'root' })
export class PlatformIdentityService {
  private readonly msal = inject(MsalService, { optional: true });
  readonly auth0 = environment.authenticationProvider === 'auth0' ? inject(Auth0SessionService) : null;

  get fingerprint(): string | null {
    if (this.auth0) {
      const user = this.auth0.session?.user;
      return user ? `auth0:${user.identityReference}:${user.id}` : null;
    }
    const account = this.msal?.instance.getActiveAccount();
    return account?.homeAccountId && account?.tenantId ? `${account.tenantId}:${account.homeAccountId}` : null;
  }

  get authenticated(): boolean {
    return this.auth0 ? Boolean(this.auth0.session) : Boolean(this.msal?.instance.getAllAccounts().length);
  }

  get isPlatformAdmin(): boolean {
    if (this.auth0) return this.auth0.session?.user.roles.includes('platform-admin') === true;
    const account = this.msal?.instance.getActiveAccount() ?? this.msal?.instance.getAllAccounts()[0];
    const roles = account?.idTokenClaims?.roles;
    if (Array.isArray(roles) && roles.includes('platform-admin')) return true;
    const domain = account?.username?.trim().toLowerCase().split('@')[1];
    return Boolean(domain && environment.internalAdminEmailDomains.includes(domain));
  }
}
